import {
  AlertDialog, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Warning } from "@phosphor-icons/react";

export default function AfipErrorDialog({ afipError, onClose }) {
  return (
    <AlertDialog open={!!afipError} onOpenChange={(v) => !v && onClose()}>
      <AlertDialogContent className="max-w-xl">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading flex items-center gap-2">
            <Warning size={18} weight="fill" className="text-red-600" />
            AFIP rechazó la factura
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-[13px]">
              <p>
                Comprobante <span className="font-mono">
                  {afipError?.factura?.tipo_comprobante} {afipError?.factura?.numero}
                </span> de {afipError?.factura?.contraparte_nombre}
              </p>
              {afipError?.excepcion && (
                <div className="border border-red-200 rounded-sm bg-red-50 p-3 text-[12px] font-mono text-red-800">
                  {afipError.excepcion}
                </div>
              )}
              {afipError?.errores?.length > 0 && (
                <div>
                  <div className="text-[10px] uppercase font-mono text-[#666] tracking-widest mb-1">Errores</div>
                  <ul className="border border-red-200 rounded-sm bg-red-50 p-3 space-y-1">
                    {afipError.errores.map((e, i) => (
                      <li key={i} className="text-[12px] font-mono text-red-800">
                        {typeof e === "string" ? e : `${e.Code || ""}: ${e.Msg || JSON.stringify(e)}`}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {afipError?.observaciones?.length > 0 && (
                <div>
                  <div className="text-[10px] uppercase font-mono text-[#666] tracking-widest mb-1">Observaciones</div>
                  <ul className="border border-amber-200 rounded-sm bg-amber-50 p-3 space-y-1">
                    {afipError.observaciones.map((o, i) => (
                      <li key={i} className="text-[12px] font-mono text-amber-800">
                        {typeof o === "string" ? o : `${o.Code || ""}: ${o.Msg || JSON.stringify(o)}`}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <p className="text-[11px] text-[#666]">
                La factura sigue en el ERP. Corregí lo indicado (CUIT del cliente, importes, etc.) y volvé a intentar.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-sm">Cerrar</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
